document.addEventListener('alpine:init', () => {
  Alpine.data('bundle', () => ({
    canAddItem: false,
    mobileMenuOpen: false,

    bag: [
      null,
      null,
      null,
      null,
      null,
    ],

    offers: [
      null,
      null,
      window.bundleSettings.bundleOfferText || 'Unlock 20% Off',
      'Get a free gift',
      null
    ],

    loading: false,

    get total() {
      // Calculate total price from all items in the bag
      let subtotal = this.bag
        .filter(item => item !== null && !item.isGift)
        .reduce((total, item) => total + item.price, 0)
        .toFixed(0);

      const discountPercentage = window.bundleSettings.bundleDiscountPercentage ?? 20;
      const discount = subtotal * (discountPercentage / 100);
      const total = (subtotal - discount).toFixed(0);

      return "<span class='bundle-compare-at_total'>$" + subtotal +'</span> $' + total;
    },

    get bagMessage(){
      const totalItemsInBag = this.bag.filter(item => item != null).length;
      if (totalItemsInBag < 1){
        return 'Add at least 3 items to start';
      }

      if (totalItemsInBag < 3){
        const remainingItems = 3 - totalItemsInBag;
        const plural = remainingItems > 1 ? 's' : '';
        return 'Add ' + (3 - totalItemsInBag) + ' more item'+plural+' to unlock savings';
      }
    },

    init(){
      const bag = localStorage.getItem('bundle_bagv2');

      if(bag){
        this.bag = JSON.parse(bag);
      }
    },
    
    addToBag(e, isGift){
      constTotalItems = this.bag.filter(item => item != null).length;
      if (constTotalItems >= 5){
        return;
      }
      
      const productId = e.currentTarget.getAttribute('product_id');
      const variantId = e.currentTarget.getAttribute('variant_id');
      const productImage = e.currentTarget.getAttribute('product_image');
      const productTitle = e.currentTarget.getAttribute('product_title');
      const priceRaw = e.currentTarget.getAttribute('price');
      const price = parseFloat(priceRaw) / 100;

      this.canAddItem = true;
      this.loading = true;

      setTimeout(() => {
        this.bag.forEach((item, index) => {
          if(item == null && this.canAddItem){
            this.bag[index] = {
              productTitle: productTitle,
              productId: productId,
              variantId: variantId,
              productImage: productImage,
              isGift: isGift,
              price: price,
            };

            this.canAddItem = false;
            return;
          }
        });

        // save bag to local storage
        localStorage.setItem('bundle_bagv2', JSON.stringify(this.bag));

        this.loading = false;
        //this.scrollToMainSection();
      }, 300);
    },

    scrollToMainSection(){
      constTotalItems = this.bag.filter(item => item != null).length;
      if (constTotalItems >= 5){
        return;
      }

      const element = document.getElementById('bundle-main-content');
      const offset = 200; // Number of pixels to offset

      // Get the element's position relative to the top of the document
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;

      // Scroll to the element minus the offset
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth'
      });
    },

    removeFromBag(index){
      this.bag[index] = null;

      // Count non-free gift items
      constTotalItems = this.bag.filter(item => item != null && !item.isGift).length;
      if (constTotalItems < 3){
        // Remove free gift
        this.bag.forEach((item, index) => {
          if(item != null && item.isGift){
            this.bag[index] = null;
            return;
          }
        });
      }

      // save bag to local storage
      localStorage.setItem('bundle_bagv2', JSON.stringify(this.bag));

      this.scrollToMainSection();
    },

    addToCart(){
      this.loading = true;

      let cartItems = [];

      const bundleId = Date.now() + Math.random().toString(36).substr(2, 9);
      this.bag.forEach((item) => {
        if(item != null){
          let properties = {
              '_bundle_id': bundleId,
              '_bundle_name': window.bundleSettings.bundleName,
              '_bundle_image': window.bundleSettings.bundleImage,
              [window.bundleSettings.bundleLockedAttribute || '_bundle_locked']: "true"
          };

          if (item.isGift){
            properties['_bundle_gift'] = 'true';
          }

          cartItems.push({
            id: item.variantId,
            quantity: 1,
            properties: properties
          }); 
        }
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: cartItems,
        }),
      }).then((response) => {
        this.loading = false;
        //window.location.href = '/checkout';
        this.bag = [null, null, null, null, null];
        //window.dispatchEvent(new CustomEvent('cart:refresh'));
        window.dispatchEvent(new CustomEvent('cart:open'));

        localStorage.removeItem('bundle_bagv2');
      }); 
    }
  }));

});
